import { ProgramApiModel } from '@cxb/content-stb-api/model/models';
import { RecommendationTrayContentApiModel } from '@cxb/content-stb-api/model/recommendationTrayContentApiModel';
import { Entity } from '@nx-data/nx-data';

export class RecoTrayContentEntity extends Entity implements RecommendationTrayContentApiModel {
  public basedOn: ProgramApiModel;
  public content: Array<ProgramApiModel>;
}
